import React from 'react';

import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';

import { Wrap } from './styled';

const CleanLayout = ({ route }: RouteConfigComponentProps) => {
  return <Wrap>{renderRoutes(route?.routes)}</Wrap>;
};

export default CleanLayout;
